import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';

import {AuthenticationService} from '../../services/authentication.service';

import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
    model: any = {};
    loading: boolean = false;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private authenticationService: AuthenticationService,
                private translate: TranslateService
    ) { }

    ngOnInit() {
        this.model.title = 'title.login';
        this.model.locale = this.route.snapshot.data['locale'];

        this.translate.use(this.model.locale);

        this.authenticationService.removeUser();
    }

    login() {
        this.loading = true;
        this.authenticationService.login(this.model.username, this.model.password, this.model.locale)
            .subscribe(
                data => {
                    this.loading = false;
                    this.router.navigate(['/']);
                },
                error => {
                    this.loading = false;
                });
    }

    changeLanguage(): void {
        this.translate.use(this.model.locale);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/login/login.component.ts